import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-scroll-up',
    imports: [MatButtonModule, NgbTooltip],
    templateUrl: './scroll-up.component.html',
    styleUrl: './scroll-up.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScrollUpComponent {
    scrollTop = output<void>();

    onScrollTop(): void {
        this.scrollTop.emit();
    }
}
